export default __webpack_public_path__ + "static/media/is.093de0f4.svg";